<div class="row  justify-content-md-center">

    <div class="col-md-1 col-0"></div>

    <div class="col-md-10 col-12 col-xs-12">

        <div class="row justify-content-md-center">

            <ng-container *ngFor="let opcion of sistemaService.menuHome; let i = index" >
                <div class="homecontainer">
                    <a class="btn btn-block btnOpcion" style="white-space: normal" (click)="IrPagina(opcion)">

                        <div *ngIf="opcion.TipoIconoId == TipoIconoEnum.AweSomeFont">
                            <span class="fa {{opcion.Icono}}  icono"  ></span>
                        </div>

                        <div *ngIf="opcion.TipoIconoId == TipoIconoEnum.Svg">
                            <svg-icon class="iconoSVG" src="data:image/svg+xml;base64,{{opcion.Icono}}" ></svg-icon>
                        </div>

                        <div class="divisor8"></div>

                        <span>{{opcion.Titulo}}</span>
                    </a>

                </div>
            </ng-container>

        </div>
    </div>

    <div class="col-md-1 col-0"></div>
</div>

